import { UI } from '../game/constants';

export function drawText(
  ctx: CanvasRenderingContext2D,
  text: string,
  x: number,
  y: number,
  align: CanvasTextAlign = 'left',
  font = UI.font,
  color = UI.colorPrimary,
): void {
  ctx.save();
  ctx.font = font;
  ctx.textAlign = align;
  ctx.fillStyle = UI.shadow;
  ctx.fillText(text, x + 1, y + 1);
  ctx.fillStyle = color;
  ctx.fillText(text, x, y);
  ctx.restore();
}

export function drawCenteredText(
  ctx: CanvasRenderingContext2D,
  text: string,
  y: number,
  font = UI.largeFont,
  color = UI.colorPrimary,
): void {
  drawText(ctx, text, 160, y, 'center', font, color);
}
